// src/components/SavePatternModal.jsx
import React, { useState } from "react";
import AutocompleteInput from "./AutocompleteInput";

export function SavePatternModal({
  onClose,
  patternName,
  setPatternName,
  folderName,
  setFolderName,
  onSavePattern,
  savedPatterns,
  isAutosave = false,
  onConfirm = null,
  title = "Save Pattern",
  subtitle = null,
}) {
  // Local state for modal inputs
  const [localPatternName, setLocalPatternName] = useState(patternName);
  const [localFolderName, setLocalFolderName] = useState(folderName);

  // Extract unique folders for autocomplete
  const uniqueFolders = [
    ...new Set(
      savedPatterns
        .map((pattern) => pattern.folder || "Uncategorized")
    ),
  ];

  const handleSave = async () => {
    const trimmedName = localPatternName.trim() || "My Pattern";
    const trimmedFolder = localFolderName.trim() || "Uncategorized";
    
    if (isAutosave && onConfirm) {
      // For autosave, use the onConfirm callback
      onConfirm(trimmedName, trimmedFolder);
    } else {
      // For manual save, update state first, then call save with override
      setPatternName(trimmedName);
      setFolderName(trimmedFolder);
      
      // Wait a tiny bit for state to update, then call save
      setTimeout(async () => {
        try {
          await onSavePattern({
            overridePatternName: trimmedName,
            overrideFolderName: trimmedFolder
          });
          onClose();
        } catch (error) {
          console.error('Save failed:', error);
          // Don't close the modal if save failed
        }
      }, 10);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[200]">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <div className="flex justify-between items-center mb-4">
          <div>
            <h2 className="text-xl font-bold">{title}</h2>
            {subtitle && (
              <p className="text-sm text-gray-600 mt-1">{subtitle}</p>
            )}
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="mb-4">
          <label className="block font-medium text-sm mb-1">Pattern Name</label>
          <input
            type="text"
            value={localPatternName}
            onChange={(e) => setLocalPatternName(e.target.value)}
            placeholder="Enter pattern name"
            className="border p-2 rounded w-full"
            autoFocus
          />
        </div>

        <div className="mb-4">
          <label className="block font-medium text-sm mb-1">Folder</label>
          <AutocompleteInput
            value={localFolderName}
            onChange={(e) => setLocalFolderName(e.target.value)}
            onSelect={(suggestion) => setLocalFolderName(suggestion)}
            suggestions={uniqueFolders}
            placeholder="Enter folder name (optional)"
            className="border p-2 rounded w-full"
            maxSuggestions={5}
          />
        </div>

        <div className="flex justify-end gap-2 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded hover:bg-gray-100"
          >
            {isAutosave ? "Skip Saving" : "Cancel"}
          </button>
          <button
            onClick={handleSave}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            {isAutosave ? "Save Pattern" : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
